import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { deletedArticlesSlice } from "./deletedArticlesSlice"
import axios from "axios"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"

export const fetchArticleWorkspaces = createAsyncThunk(
	"recentlyReviewed/fetchArticleWorkspaces",
	async (workspaceId, {getState, rejectWithValue}) => {
		const {recentlyReviewed} = getState()
		const workspace = ensureWorkspace(recentlyReviewed, workspaceId)
		const articleList = workspace.articles
		const articleWorkspaceIds = articleList.map(x => x.articleId)
		const queryString = articleWorkspaceIds.map(id => `articleIds=${id}`).join("&")
		if (queryString.length <= 0) {
			return []
		}
		try {
			const url = `/api/workspace/${workspaceId}/articleWorkspaces?${queryString}`
			const response = await axios.get(url)
			return {articles: response.data, workspaceId}
		} catch (error) {
			return rejectWithValue(error?.response?.message)
		}
	}
)

const initialState = {
	articles: [],
}
const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialState)
export const recentlyReviewedSlice = createSlice({
	name: "recentlyReviewed",
	initialState: {
		articles: {},
		currentWorkspaceId: -1,
		byWorkspace: {}
	},
	reducers: {
		setArticles: (state, action) => {
			const {articles, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.articles = articles
			state.articles[workspaceId] = articles
		},
		addArticle: (state, action) => {
			const {articleWorkspace, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)

			const recentlyViewedList = workspace.articles || []
			const recentlyViewedListWithoutNewArticle = recentlyViewedList.filter(article => article.articleId !== articleWorkspace.articleId)
			workspace.articles = [articleWorkspace, ...recentlyViewedListWithoutNewArticle]
		},
		clearArticles: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.articles = initialState.articles
		},
		updateArticle: (state, action) => {
			const {importedArticle, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			const recentlyViewedList = workspace.articles || []
			workspace.articles = recentlyViewedList.map(oldArticle => {
				if (oldArticle.articleId === importedArticle.articleId) {
					return importedArticle
				} else {
					return oldArticle
				}
			})
		}
	},
	extraReducers: (builder) => {
		builder.addCase(
			fetchArticleWorkspaces.fulfilled,
			(state, action) => {
				const {articles: incomingWorkspaceArticles, workspaceId} = action.payload
				const workspace = ensureWorkspace(state, workspaceId)
				const currentArticles = workspace.articles
				
				workspace.articles = currentArticles.map(article => {
					const match = incomingWorkspaceArticles.find(incomingArticle => incomingArticle.articleId === article.articleId)
					return match || article
				})
			}
		)
		//TODO: after refactor of deletedArticlesSlice
		builder.addCase(deletedArticlesSlice.actions.addDeletedArticle, (state, action) => {
			const deletedArticle = action.payload
			const recentlyViewedList = state.articles[state.currentWorkspaceId] || []
			const newList = recentlyViewedList.map(oldArticle => {
				if (oldArticle.articleId === deletedArticle.articleId) {
					return {
						article: oldArticle.article,
						...deletedArticle
					}
				} else {
					return oldArticle
				}
			})

			state.articles[state.currentWorkspaceId] = newList
		})
	}
})

export const { addArticle, setArticles, clearArticles, updateArticle } =
	recentlyReviewedSlice.actions

export const selectRecentlyViewedArticles = (state, workspaceId) => state.recentlyReviewed.byWorkspace[workspaceId]?.articles ?? initialState.articles

export default recentlyReviewedSlice.reducer
